import { StrictMode, Suspense } from "react";
import * as Sentry from "@sentry/react";
import { Initialization } from "@base/_Init";
import { isDebug } from "@base/BuildEnvironment";
import { ZIndices } from "@biz/ZIndices.ts";
import { SpinningOverlay } from "@viz/spinner/SpinningOverlay.tsx";
import { SvgSpinner } from "@viz/spinner/SvgSpinner.tsx";
import { ShopSkin } from "@viz/ui/branding/ShopSkin.ts";
import { LazyApp } from "src/main.lazy.ts";
import ReactDOM from "react-dom/client";

const withSentry = !isDebug();
if (withSentry) {
  Sentry.init({
    dsn: "https://10f3a4a4e740a8c75a0d667de1438edc@o4509112763678721.ingest.de.sentry.io/4509112765972560",
    environment: isDebug() ? "development" : "production",
  });
}


Initialization.init();

export const LoaderApp = () => {
  return <>
    <Suspense fallback={<><SvgSpinner visible={true} title={<div style={{ fontFamily: "sans-serif" }}>Loading...</div>} backgroundColor={ShopSkin.palette.textColor_grey} zIndex={1000} /></>}>
      <LazyApp />
    </Suspense>    
    <SpinningOverlay zIndex={ZIndices.Spinner} />
  </>
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LoaderApp />
  </StrictMode>
)